import { useRef, useEffect, memo } from 'react';
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { getDecryptLocalStorage } from '../../utils/global_functions';
import { LOCAL_STORAGE_KEYS, THEME_TYPE } from '../../utils/global_variables';

// Register necessary components
Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const DeliveryQuantityChart = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const theme = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.THEME);

  useEffect(() => {
    const ctx = chartRef.current.getContext('2d');

    // Dynamically build labels and datasets based on available data
    const labels = [];
    const delData = [];
    const volData = [];

    if (data.todayvol) {
      labels.push('Today');
      delData.push(0); // Today has no del value
      volData.push(data?.todayvol || 0);
    }
    if (data.yesterdaydel || data.yesterdayvol) {
      labels.push('Yesterday');
      delData.push(data.yesterdaydel || 0);
      volData.push(data.yesterdayvol || 0);
    }
    if (data.fiveDaydel || data.fivedayvol) {
      labels.push('5 Days Avg');
      delData.push(data.fiveDaydel || 0); // Use 0 if value is not available
      volData.push(data.fivedayvol || 0);
    }
    if (data.thirtyDaydel || data.thirtyDayvol) {
      labels.push('30 Days Avg');
      delData.push(data.thirtyDaydel || 0);
      volData.push(data.thirtyDayvol || 0);
    }

    // Chart data
    const chartData = {
      labels, // Y-axis labels
      datasets: [
        {
          label: "Total Volume", // Label for vol data
          data: volData,
          borderColor: 'rgba(54, 162, 235, 1)', // Blue color for vol
          backgroundColor: 'rgba(71, 73, 132, 1.0)',
        },
        {
          label: "Delivery", // Label for del data
          data: delData,
          borderColor: 'rgba(255, 99, 132, 1)', // Red color for del
          backgroundColor: "rgba(109, 170, 227, 1.0)",
        },

      ],
    };

    // Chart options
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          bottom: 50
        }
      },
      indexAxis: 'y', // Horizontal bar chart
      plugins: {
        tooltip: {
          enabled: true,
          backgroundColor: 'white',
          titleColor: 'black',
          bodyColor: 'black',
          borderColor: 'black',
          borderWidth: 1,
          displayColors: true, // Show color boxes in tooltips
          callbacks: {
            title: (tooltipItems) => tooltipItems[0].label, // Show category name in tooltip
            label: (tooltipItem) => {
              const value = tooltipItem.raw;
              return `${value.toLocaleString()}`; // Format values with commas
            },
          },
        },
        legend: {
          display: true, // Show legend for del and vol
          position: "bottom",
          usePointStyle: false,
          boxWidth:10,
          boxHeight: 10,
          labels: {
            color: theme === THEME_TYPE.DARK ? "white" : 'black',
            font: {
              size: 12,
              family: 'rubikregular'
            },
          }
        }, datalabels: {
          color: theme === THEME_TYPE.DARK ? "white" : 'black',
          display: false, // Disable labels on bars (only if using chartjs-plugin-datalabels)
        },
      },
      scales: {
        x: {
          beginAtZero: true,
          ticks: {
            font: {
              size: 12,
              family: 'rubikregular'
            },
            maxTicksLimit: 5, // Limit the number of ticks to 3
            color: theme === THEME_TYPE.DARK ? "white" : 'black', // X-axis ticks color
            callback: (value) => value.toLocaleString(), // Format X-axis values with commas
          },
        },
        y: {
          ticks: {
            font: {
              size: 12,
              family: 'rubikregular'
            },
            color: theme === THEME_TYPE.DARK ? "white" : 'black', // Y-axis label text color
          },
          grid: {
            drawOnChartArea: false, // Hide grid lines for a cleaner look
          },
        },
      },
    };

    // Destroy previous chart instance if it exists
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    // Create the chart instance
    chartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: chartData,
      options,
    });

    // Cleanup on unmount
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]); // Re-run if data changes

  useEffect(() => {
    if (true) {
      const canvas = document.querySelector('#chart-canvas')
      if (canvas) {
        canvas.style.height = '88%'
        canvas.style.width = '90%'
      } else { }
    }
    else { }

  }, [])

  return <canvas id='chart-canvas' ref={chartRef} width="600" height="400"></canvas>;
};

export default memo(DeliveryQuantityChart);
